import { SwitchRole } from '@/bundle/pages/SwitchRolePage/ui/SwitchRole';
import { AuthLayout } from '../../ui/AuthLayout/AuthLayout';
import { useNavigate } from 'react-router';
import { LayoutSpinner, LayoutWrapper } from '@/bundle/Layouts/styles';
import { authTokenService } from '../../../shared/services/authTokenService';
import { getLoginPath } from '@/bundle/Auth/LoginFlow/LoginPage/path/path';
import { useLogin } from '../../hooks/useLogin';
import { UserRoleType } from '@/const/user';
import { AdBanner } from '@/bundle/shared/components/banner/AdBanner/AdBanner';
import { amplitudeService } from '@/services/amplitudeService/amplitudeService';
import { AMPLITUDE_EVENTS } from '@/services/amplitudeService/amplitudeEvents';
import { useHasAnyOrganizationAdminRole } from '@/bundle/shared/hooks/useHasAnyOrganizationAdminRole';
import { useEffect, useState } from 'react';
import { decodeToken } from '@/helpers/tokenHelpers';
import { AccessTokenType } from '@/types/sharedTypes';
import { useLogout } from '@/bundle/shared/hooks/useLogout';
import { useTranslation } from 'react-i18next';
import { getRolesList } from '@/helpers/userHelpers';

export const SelectRolePage = () => {
  const navigate = useNavigate();
  const { login } = useLogin();
  const { mutate: logoutMutate } = useLogout();
  const { hasAnyOrganizationAdminRole } = useHasAnyOrganizationAdminRole();
  const { t } = useTranslation('login');

  const [loading, setLoading] = useState(true);
  const [activeRoles, setActiveRoles] = useState<UserRoleType[]>([]);

  useEffect(() => {
    const tokens = authTokenService.getTokens();

    if (!tokens || !tokens?.access) {
      navigate(getLoginPath());

      return;
    }

    const { active_roles } = decodeToken<AccessTokenType>(tokens?.access);
    const tokenActiveRoles = getRolesList(active_roles);

    if (tokenActiveRoles?.length === 1) {
      navigate(getLoginPath());

      return;
    }

    setActiveRoles(tokenActiveRoles);
    setLoading(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selectRole = (selectedRole: UserRoleType) => {
    amplitudeService.logEvent(AMPLITUDE_EVENTS.SwitchRoleSelectDashboardDuringLoginSuccess);

    const tokens = authTokenService.getTokens();

    login({ access: tokens.access, refresh: tokens.refresh }, selectedRole);
  };

  const navigateToLogin = () => {
    logoutMutate();
  };

  return loading ? (
    <LayoutWrapper>
      <LayoutSpinner />
    </LayoutWrapper>
  ) : (
    <AuthLayout banner={hasAnyOrganizationAdminRole ? null : <AdBanner isClosable={false} />}>
      <SwitchRole
        activeRoles={activeRoles}
        onSelect={selectRole}
        onBack={navigateToLogin}
        backButtonText={t('login:returnToLoginButtonLabel')}
      />
    </AuthLayout>
  );
};
